import React from "react";
import { matchRoutes, useLocation } from "react-router-dom";
import { IS_TEST_BUILD } from "../lib/appEnv";
import { ROUTE_OBJECTS } from "../lib/routePatterns";

/** The matched route pattern ("/events/:eventId"), or null before any route matches. */
function useRoutePattern() {
  const location = useLocation();
  const matches = matchRoutes(ROUTE_OBJECTS, location);
  return matches?.length ? matches[matches.length - 1].route.path : null;
}

function Badge() {
  const pattern = useRoutePattern();
  return (
    <div className="test-badge" data-testid="testBuild.badge" role="img" aria-label={pattern ? `TEST · ${pattern}` : "TEST"}>
      TEST
    </div>
  );
}

/**
 * Small amber "TEST" pill on every page of a TEST-environment build (same look as the mobile
 * TestBuildBadge), so nobody mistakes it for production. Its aria-label carries the matched
 * route pattern for test tooling. Never rendered in a production build. Must sit inside the router.
 */
export default function TestBuildBadge() {
  return IS_TEST_BUILD ? <Badge /> : null;
}
